import type { LocaleType } from 'framework/types/config'
import { LOCALE } from 'framework/settings/localeSetting'

import { set } from 'lodash-es'

export const lang = ref('')

export const filterTitle = (curSystemItem) => {
  if (!curSystemItem) return null
  const titleEnum = {
    [LOCALE.ZH_CN]: 'title',
    [LOCALE.EN_US]: 'en_title',
  }
  return curSystemItem[titleEnum[lang.value]]
}

export const loadLocalePool: LocaleType[] = []

export function getHtmlPageLang() {
  return document.querySelector('html').getAttribute('lang')
}

export function setHtmlPageLang(locale: LocaleType) {
  document.querySelector('html')?.setAttribute('lang', locale)
  lang.value = locale
}

export function setLoadLocalePool(cb: (loadLocalePool: LocaleType[]) => void) {
  cb(loadLocalePool)
}

export function genMessage(langs: Record<string, Record<string, any>>, prefix = 'lang') {
  const obj: Recordable = {}

  Object.keys(langs).forEach((key) => {
    const langFileModule = langs[key].default
    let fileName = key.replace(`./${prefix}/`, '').replace(/^\.\//, '')
    const lastIndex = fileName.lastIndexOf('.')
    fileName = fileName.substring(0, lastIndex)
    const keyList = fileName.split('/')
    const moduleName = keyList.shift()
    const objKey = keyList.join('.')

    if (moduleName) {
      if (objKey) {
        set(obj, moduleName, obj[moduleName] || {})
        set(obj[moduleName], objKey, langFileModule)
      } else {
        set(obj, moduleName, langFileModule || {})
      }
    }
  })
  return obj
}
